import lightTheme from './light'
import darkTheme from './dark'
export const theme = {
    lightTheme,
    darkTheme
}